import BaseViewModel from '@src/mobx-store/vm/base-view-model';
import { $$tracker } from '@src/tracker';
import rootStore from '@src/mobx-store/root-store';
import ZtServiceFactory from '@src/services/zt';

/**
 * 依赖 view model
 */
export default class DependencyViewModel extends BaseViewModel {
  get $ztServices() {
    if (!this._$ztServices) {
      const ztServiceFactory = new ZtServiceFactory({ checkIfComponentUnmount: () => this.$$isUnmount });
      this._$ztServices = ztServiceFactory.createService();
    }
    return this._$ztServices;
  }

  get $tracker() {
    return $$tracker;
  }

  get $rootStore() {
    return rootStore;
  }
}



// WEBPACK FOOTER //
// ./src/mobx-store/vm/dependency-view-model.js